/**
 * @generated SignedSource<<b9cbc490bed03c6da2be74481d6678ec>>
 * @relayHash b269ae0c54b2a77410c3da45f1ef901b
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b269ae0c54b2a77410c3da45f1ef901b

import { ConcreteRequest } from 'relay-runtime';
export type UserRole = "CALL_CENTER_AGENT" | "CUSTOMER_SERVICE_CENTER" | "DOCTOR" | "MEDICAL_SUPERVISOR" | "NONE" | "NURSING_PROFESSIONAL" | "SOFIA_ADMIN" | "SOFIA_ADMIN_AI_ADMIN" | "SOFIA_ADMIN_BUSINESS_ADMIN" | "SOFIA_ADMIN_BUSINESS_EDITOR" | "SOFIA_ADMIN_MEDICAL_ADMIN" | "SOFIA_ADMIN_TECHNICAL_ADMIN";
export type useWorkingUserOptionsQuery$variables = {
  roles?: ReadonlyArray<UserRole> | null;
  skip: boolean;
};
export type useWorkingUserOptionsQuery$data = {
  readonly workingUsers?: ReadonlyArray<string>;
};
export type useWorkingUserOptionsQuery = {
  response: useWorkingUserOptionsQuery$data;
  variables: useWorkingUserOptionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "roles"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "roles",
            "variableName": "roles"
          }
        ],
        "kind": "ScalarField",
        "name": "workingUsers",
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useWorkingUserOptionsQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useWorkingUserOptionsQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "b269ae0c54b2a77410c3da45f1ef901b",
    "metadata": {},
    "name": "useWorkingUserOptionsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "bb1310b41d2d83504b126747defe9f3f";

export default node;
